import { Paper, Theme, styled } from '@material-ui/core';

const SeriesCardPaper = styled(Paper)<Theme>(({ theme }) => ({
  background: theme.palette.common.white,
  border: `1px solid ${theme.config.appbarColors.borderColor}`,
  borderRadius: theme.config.borderRadiusCluster,
  position: 'relative',
  height: '100%',
  padding: theme.spacing(2),
  overflow: 'hidden',
  cursor: 'pointer',
  '&:hover': {
    background: theme.config.appbarColors.background,
  },
  '&.show-progress-and-scores': {
    padding: '2.5rem 2rem 8rem 2rem',
  },
}));

export default SeriesCardPaper;
